<template>
  <div v-if="isVisible" class="farm-loader-overlay">
    <div class="farm-loader">
      <!-- Contenedor principal del loader -->
      <div class="loader-container">
        
        <!-- Sol central -->
        <div class="sun-container">
          <div class="sun"></div>
          <div class="sun-glow"></div>
        </div>
        
        <!-- Plantas/cultivos girando alrededor -->
        <div class="plant plant-1">🌱</div>
        <div class="plant plant-2">🌾</div>
        <div class="plant plant-3">🌿</div>
        <div class="plant plant-4">🍃</div>
        
        <!-- Tractor simple -->
        <div class="tractor">🚜</div>
        
        <!-- Elementos decorativos -->
        <div class="particle particle-1"></div>
        <div class="particle particle-2"></div>
        <div class="particle particle-3"></div>
        <div class="particle particle-4"></div>
      </div>
      
      <!-- Texto de carga -->
      <div class="loading-text">
        <p>{{ currentMessage }}</p>
        <div class="dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FarmLoader',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    messages: {
      type: Array,
      default: () => [
        'Preparando el terreno...',
        'Sembrando los datos...',
        'Regando la información...',
        'Cosechando resultados...',
        'Guardando visita...',
        'Cargando datos...'
      ]
    }
  },
  data() {
    return {
      currentMessageIndex: 0,
      messageInterval: null
    }
  },
  computed: {
    isVisible() {
      return this.visible;
    },
    currentMessage() {
      return this.messages[this.currentMessageIndex];
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.startMessageRotation();
      } else {
        this.stopMessageRotation();
      }
    }
  },
  methods: {
    startMessageRotation() {
      this.currentMessageIndex = 0;
      this.messageInterval = setInterval(() => {
        this.currentMessageIndex = (this.currentMessageIndex + 1) % this.messages.length;
      }, 2000);
    },
    stopMessageRotation() {
      if (this.messageInterval) {
        clearInterval(this.messageInterval);
        this.messageInterval = null;
      }
    }
  },
  beforeDestroy() {
    this.stopMessageRotation();
  }
}
</script>

<style scoped>
.farm-loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(3px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

.farm-loader {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

.loader-container {
  position: relative;
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Sol central */
.sun-container {
  position: relative;
  z-index: 10;
}

.sun {
  width: 60px;
  height: 60px;
  background: linear-gradient(45deg, #FFD700, #FFA500);
  border-radius: 50%;
  box-shadow: 0 0 20px rgba(255, 215, 0, 0.5);
  animation: sunRotate 3s linear infinite;
}

.sun-glow {
  position: absolute;
  top: -10px;
  left: -10px;
  width: 80px;
  height: 80px;
  background: radial-gradient(circle, rgba(255, 215, 0, 0.3) 0%, transparent 70%);
  border-radius: 50%;
  animation: sunPulse 2s ease-in-out infinite alternate;
}

/* Plantas orbitando */
.plant {
  position: absolute;
  font-size: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: orbit 4s linear infinite;
  transform-origin: 100px 100px;
}

.plant-1 {
  top: 0px;
  left: 0px;
  animation-delay: 0s;
}

.plant-2 {
  top: 0px;
  left: 0px;
  animation-delay: -1s;
}

.plant-3 {
  top: 0px;
  left: 0px;
  animation-delay: -2s;
}

.plant-4 {
  top: 0px;
  left: 0px;
  animation-delay: -3s;
}

/* Tractor */
.tractor {
  position: absolute;
  font-size: 32px;
  top: 150px;
  left: 78px;
  animation: tractorBounce 2s ease-in-out infinite;
}

/* Partículas decorativas */
.particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: #32CD32;
  border-radius: 50%;
  animation: particleFloat 3s ease-in-out infinite;
}

.particle-1 {
  top: 30px;
  left: 30px;
  animation-delay: 0s;
}

.particle-2 {
  top: 40px;
  right: 40px;
  animation-delay: -0.5s;
}

.particle-3 {
  bottom: 50px;
  left: 40px;
  animation-delay: -1s;
}

.particle-4 {
  bottom: 30px;
  right: 30px;
  animation-delay: -1.5s;
}

/* Texto de carga */
.loading-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.loading-text p {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #2F4F2F;
  margin: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.dots {
  display: flex;
  gap: 8px;
}

.dots span {
  width: 10px;
  height: 10px;
  background: #32CD32;
  border-radius: 50%;
  animation: dotBounce 1.4s ease-in-out infinite both;
}

.dots span:nth-child(1) { animation-delay: -0.32s; }
.dots span:nth-child(2) { animation-delay: -0.16s; }
.dots span:nth-child(3) { animation-delay: 0s; }

/* Animaciones */
@keyframes fadeIn {
  from { 
    opacity: 0;
    transform: scale(0.9);
  }
  to { 
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes sunRotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes sunPulse {
  0% { 
    transform: scale(1);
    opacity: 0.6;
  }
  100% { 
    transform: scale(1.2);
    opacity: 0.3;
  }
}

@keyframes orbit {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes tractorBounce {
  0%, 100% { 
    transform: translateY(0px) rotate(-2deg);
  }
  50% { 
    transform: translateY(-5px) rotate(2deg);
  }
}

@keyframes particleFloat {
  0%, 100% { 
    transform: translateY(0px);
    opacity: 0.7;
  }
  50% { 
    transform: translateY(-15px);
    opacity: 1;
  }
}

@keyframes dotBounce {
  0%, 80%, 100% { 
    transform: scale(0);
    opacity: 0.5;
  } 
  40% { 
    transform: scale(1);
    opacity: 1;
  }
}

/* Responsive */
@media (max-width: 480px) {
  .loader-container {
    width: 150px;
    height: 150px;
  }
  
  .sun {
    width: 45px;
    height: 45px;
  }
  
  .sun-glow {
    width: 65px;
    height: 65px;
    top: -10px;
    left: -10px;
  }
  
  .plant {
    font-size: 20px;
    transform-origin: 75px 75px;
  }
  
  .plant-1 { top: 0px; left: 0px; }
  .plant-2 { top: 0px; left: 0px; }
  .plant-3 { top: 0px; left: 0px; }
  .plant-4 { top: 0px; left: 0px; }
  
  .tractor {
    font-size: 24px;
    top: 110px;
    left: 60px;
  }
  
  .loading-text p {
    font-size: 16px;
  }
}
</style>